import React, { useState, useEffect } from "react";
import { interbranchAdminSideMenu } from "../../../pages/InterbranchAdmin/constants";
import DailyConsultation from "./Charts/DailyConsultation/DailyConsultation";
import DoughnutChart from "./Charts/DoughnutChart/DoughnutChart";
import DashboardSpanSelect from "./DashboardSpanSelect/DashboardSpanSelect";
import styles from "./index.module.scss";
import { fetchConsolidatedAnalytics, fetchCountofConsultations, fetchLatestAppointments, fetchLatestRequestedAppointments, getCountOfDetails } from "../../../actions/InterbranchAdminActions";
import { useDispatch } from "react-redux";
import moment from "moment";
import DefaultImage from "../../../assets/ic_default_user.svg";
import BarChart from "./Charts/BarChart/BarChart";
import InterBranchAdminDashboardDataTab from "./DataTab/Index";
import { Skeleton } from "antd";
import AppDatePicker from "../../UI/app-date-picker/AppDatePicker";

function InterbranchAdmindashboard({ setActiveleft, selectedDashboardComponents, dashboardItemsList, setExpandedAccordion, setHeaderLeftTitle }) {
	const [selectedSpan, setSelectedSpan] = useState("Weekly");
	const [latestAppointments, setLatestAppointments] = useState([]);
	const [latestRequestedAppointments, setLatestRequestedAppointments] = useState([]);
	const [consultationsCount, setConsultationCount] = useState([]);
	const [countDetails, setCountDetails] = useState([]);
	const [consolidatedData, setConsolidatedData] = useState([]);
	const [isLoading, setLoading] = useState(true);

	const dispatch = useDispatch();

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				// Call dispatch
				const response = dispatch(fetchLatestAppointments());
				setLatestAppointments(response);
			} catch (error) {
				console.error(error);
			}
		};
		fetchAppointments();
	}, [dispatch]);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				// Call dispatch
				const response = await dispatch(fetchLatestRequestedAppointments());

				setLatestRequestedAppointments(response);
			} catch (error) {
				console.error(error);
			}
		};
		fetchAppointments();
	}, [dispatch]);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				// Call dispatch
				const response = await dispatch(fetchCountofConsultations(selectedSpan));
				console.debug("fetchCountofConsultations", response);
				setConsultationCount(response);
			} catch (error) {
				console.error(error);
			}
		};
		fetchAppointments();
	}, [dispatch, selectedSpan]);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				// Call dispatch
				const response = await dispatch(getCountOfDetails());
				console.debug("getCountOfDetails", response);
				setCountDetails(response);
			} catch (error) {
				console.error(error);
			}
		};
		fetchAppointments();
	}, [dispatch]);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				// Call dispatch
				const response = await dispatch(fetchConsolidatedAnalytics(selectedSpan));
				console.debug("fetchConsolidatedAnalytics", response);
				setConsolidatedData(response);
				setLoading(false);
			} catch (error) {
				console.error(error);
			}
		};
		fetchAppointments();
	}, [dispatch, selectedSpan]);

	console.log("consolidateData", consolidatedData);

	let dashboardData = {
		topCounts: [
			{
				name: "Confirmed appointments",
				count: consolidatedData?.countOfDetails?.apptCount || "0",
				icon: "event_available",
				// caption: {
				//   count: consolidatedData?.data?.patientCount?.newPatientCount || "0",
				//   text: "new users today",
				// },
			},
			{
				name: "Payments recieved ",
				count: "Rs. "+consolidatedData?.countOfDetails?.totalPayment || "0",
				icon: "payments",
				// caption: {
				//   count: consolidatedData?.countOfDetails?.paymentCount || "0",
				//   text: "payments today",
				// },
			},
			{
				name: "Appointment requests",
				count: consolidatedData?.countOfDetails?.apptReqCount || "0",
				icon: "free_cancellation",
				// caption: {
				//   count: consolidatedData?.countOfDetails?.apptReqCount || "0",
				//   text: "appointment requests",
				// },
			},
			// {
			//   name: "Total Refunds",
			//   count: countDetails.totalRefund || "0",
			//   caption: {
			//     count: countDetails.todayRefund || "0",
			//     text: "refund today",
			//   },
			// },
			// {
			//   name: "Total Doctors online",
			//   count: countDetails.activeDoctors || "0",
			//   caption: {
			//     count: countDetails.totalDoctors - countDetails.activeDoctors || "0",
			//     text: "doctors are offline",
			//   },
			// },
		],
		latestAppointments: [
			{
				appointmentId: 10001,
				appointmentDate: "16 March 2023",
				doctorName: "Dr. John Doe",
				patientName: "Alice Smith",
			},
			{
				appointmentId: 10002,
				appointmentDate: "16 March 2023",
				doctorName: "Dr. Jane Smith",
				patientName: "Bob Johnson",
			},
			{
				appointmentId: 10003,
				appointmentDate: "16 March 2023",
				doctorName: "Dr. Mark Lee",
				patientName: "Cindy Kim",
			},
			{
				appointmentId: 10004,
				appointmentDate: "16 March 2023",
				doctorName: "Dr. Sarah Chen",
				patientName: "David Lee",
			},
			{
				appointmentId: 10005,
				appointmentDate: "16 March 2023",
				doctorName: "Dr. Michael Johnson",
				patientName: "Emily Wang",
			},
		],
		dailyAppointments: [
			{
				appointmentId: 10001,
				appointmentTime: "03:00 PM",
				doctorName: "Dr. John Doe",
				patientName: "Alice Smith",
			},
			{
				appointmentId: 10002,
				appointmentTime: "03:00 PM",
				doctorName: "Dr. Jane Smith",
				patientName: "Bob Johnson",
			},
			{
				appointmentId: 10003,
				appointmentTime: "03:00 PM",
				doctorName: "Dr. Mark Lee",
				patientName: "Cindy Kim",
			},
			{
				appointmentId: 10004,
				appointmentTime: "03:00 PM",
				doctorName: "Dr. Sarah Chen",
				patientName: "David Lee",
			},
			{
				appointmentId: 10005,
				appointmentTime: "03:00 PM",
				doctorName: "Dr. Michael Johnson",
				patientName: "Emily Wang",
			},
		],
	};

	let getTopCountTheme = (value) => {
		switch (value) {
			case dashboardData.topCounts[0].name:
				return styles.TopCountTheme0;
			case dashboardData.topCounts[1].name:
				return styles.TopCountTheme1;
			case dashboardData.topCounts[2].name:
				return styles.TopCountTheme2;
			case dashboardData.topCounts[3].name:
				return styles.TopCountTheme3;
			default:
				return null;
		}
	};

	let handleViewMoreAppointmentRequest = () => {
		setActiveleft(interbranchAdminSideMenu[0].options[3].name);
		setHeaderLeftTitle(interbranchAdminSideMenu[0].options[3].name);
		setExpandedAccordion([1]);
	};

	let handleViewMoreDailyAppointments = () => {
		setActiveleft(interbranchAdminSideMenu[0].options[0].name);
		setHeaderLeftTitle(interbranchAdminSideMenu[0].options[0].name);
		setExpandedAccordion([1]);
	};

	let checkIfVisible = (name) => {
		let index = selectedDashboardComponents.findIndex((e) => e.name == name);
		return selectedDashboardComponents[index]?.status;
	};

	let handleChangeConsultationSpan = (value) => {
		setSelectedSpan(value);
	};

	return (
		<div className={styles.dashboardWrap}>
			<div
				style={{
					display: "flex",
					justifyContent: "end",
					alignItems: "end",
					width: "99%",
					gap: "1rem",
				}}
			>
				{/* <AppDatePicker /> */}
				<DashboardSpanSelect value={selectedSpan} onChange={handleChangeConsultationSpan} />
			</div>
			<div className={styles.TopCountContainer}>
				{dashboardData.topCounts.map((eachData, key) => {
					return (
						<div key={key} className={`${styles.card} ${styles.TopCountContainerItem} ${getTopCountTheme(eachData?.name)}`}>
							<div className={styles.TopCountContainerItem_header}>
								<div className={styles.TopCountContainerItem_header_iconWrap}>
									<span class="material-symbols-outlined">{eachData?.icon}</span>
								</div>
								<div className={styles.TopCountContainerItem_header_countWrap}>
									{isLoading ? <Skeleton.Button style={{ width: 100 }} shape="round" size="small" active /> : <h4>{eachData?.count}</h4>}

									<span>{eachData?.name}</span>
								</div>
							</div>

							{/* <div className={styles.TopCountContainerItem_footer}>
								<div className={styles.TopCountContainerItem_footer_count}>{eachData?.caption?.count}</div>
								<div className={styles.TopCountContainerItem_footer_text}>{eachData?.caption?.text}</div>
							</div> */}
						</div>
					);
				})}
			</div>

			{checkIfVisible(dashboardItemsList[0]) ? (
				<div className={`${styles.card} ${styles.dailyConsultationWrap} `}>
					<div className={styles.cardHeader}>
						<h5>{selectedSpan} number of consultations</h5>
					</div>

					<DailyConsultation selectedSpan={selectedSpan} consultationCount={consultationsCount} />
				</div>
			) : null}

			<InterBranchAdminDashboardDataTab handleViewMoreAppointmentRequest={handleViewMoreAppointmentRequest} handleViewMoreDailyAppointments={handleViewMoreDailyAppointments} dashboardItemsList={dashboardItemsList} />
		</div>
	);
}

export default InterbranchAdmindashboard;
